/**
 * <s-dialog-switch> swaps between two inquiry dialogs: a click on a button closes the
 * dialog it sits in and opens the dialog named by data-target. When that dialog is not on
 * the page (for example the event form on the events page), it goes to data-href instead.
 */
class DialogSwitch extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('button[data-target]') : null;
      if (!button || button.getAttribute('aria-pressed') === 'true') return;
      const current = this.closest('dialog');
      const target = document.getElementById(button.dataset.target);
      current?.close();
      if (target instanceof HTMLDialogElement) {
        target.showModal();
      } else if (button.dataset.href) {
        window.location.href = button.dataset.href;
      }
    });
  }
}

if (!customElements.get('s-dialog-switch')) customElements.define('s-dialog-switch', DialogSwitch);
